import { addElementsToExcalidraw, createImageElement } from '../whiteboard/utils';
import { CollabImagesServiceV2 } from './service';
import * as CollabImageActionTypes from './actionTypes';
import { getCollabImagesState } from './funtions';
import { ENDPOINT_MESSAGE_RECEIVED_COLLAB_IMAGES_IMAGE_ID, ENDPOINT_MESSAGE_REMOVE_IMAGE } from './constants';
import { startPing, stopPing } from './ping';
import { showErrorNotification } from '../notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from '../notifications/constants';
export const joinRoomRequest = (roomId) => ({
    type: CollabImageActionTypes.JOIN_ROOM_REQUEST,
    payload: { roomId }
});
export const joinRoomFailure = (error) => ({
    type: CollabImageActionTypes.JOIN_ROOM_FAILURE,
    error
});
export const joinRoomSuccess = (roomId, images) => ({
    type: CollabImageActionTypes.JOIN_ROOM_SUCCESS,
    payload: { roomId, images }
});
export function leftRoom() {
    return (dispatch) => {
        stopPing();
        dispatch({
            type: CollabImageActionTypes.LEFT_ROOM,
        });
    };
}
export const idImageReceived = (id) => async (dispatch, getState) => {
    dispatch({
        type: CollabImageActionTypes.ID_IMAGE_RECEIVED,
        payload: {
            id
        }
    });
    const tegoServer = getState()['features/tego-server'];
    if (!tegoServer.isEnabled) {
        dispatch(shareImageBlocked("Caracteristica no habilitada."));
        return;
    }
    dispatch(imageReceivedDownloadStart(id, tegoServer.urls.tego));
};
export const idImageReceivedLocked = (cause) => ({
    type: CollabImageActionTypes.ID_IMAGE_RECEIVED_LOCKED,
    payload: {
        cause
    }
});
export const imageReceivedDownloadStart = (id, url) => async (dispatch, getState) => {
    dispatch({
        type: CollabImageActionTypes.IMAGE_RECEIVED_DOWNLOAD_START,
        payload: {
            id
        }
    });
    try {
        const data = await new CollabImagesServiceV2(url).getImageMeta(id);
        dispatch(imageReceivedDownloadSuccess(data));
        const { excalidrawApi } = getState()['features/collab-images'];
        if (excalidrawApi) {
            excalidrawApi;
        }
    }
    catch (e) {
        dispatch(imageReceivedDownloadFailure("Error del servidor"));
    }
};
export const imageReceivedDownloadSuccess = (image) => ({
    type: CollabImageActionTypes.IMAGE_RECEIVED_DOWNLOAD_SUCCESS,
    payload: {
        image
    }
});
export const imageReceivedDownloadFailure = (cause) => ({
    type: CollabImageActionTypes.IMAGE_RECEIVED_DOWNLOAD_FAILURE,
    payload: {
        cause
    }
});
/**
 * Signals the user’s intent to share an image.
 */
export const shareImageIntent = () => ({
    type: CollabImageActionTypes.SHARE_IMAGE_INTENT
});
/**
 * Blocks a share attempt, supplying a reason.
 */
export const shareImageBlocked = (cause) => ({
    type: CollabImageActionTypes.SHARE_IMAGE_BLOCKED,
    payload: { cause }
});
/**
 * Starts the upload process. Dispatches success or failure when done.
 *
 * @param upload – function that actually does the HTTP upload
 * @param conference – JitsiConference to notify peers
 * @param excalidrawApi – Excalidraw API to render the new element
 */
export const shareImageUploadStart = (upload, conference, excalidrawApi, callback) => async (dispatch) => {
    dispatch({ type: CollabImageActionTypes.SHARE_IMAGE_UPLOAD_START });
    try {
        const image = await upload();
        dispatch(shareImageUploadSuccess(image, excalidrawApi, conference, callback));
    }
    catch {
        dispatch(shareImageUploadFailure('Failed to upload image.'));
        callback?.(false);
    }
};
/**
 * Renders the newly-uploaded image on the board, notifies other participants,
 * and updates Redux state.
 */
export const shareImageUploadSuccess = (image, excalidrawApi, conference, callback) => (dispatch) => {
    const images = excalidrawApi.getSceneElements().filter(e => e.type === 'image');
    if (images.length >= 6) {
        dispatch(shareImageBlocked("6 de 6 imegenes, pruebe a borrar algunas"));
        callback?.(false);
        return;
    }
    const state = excalidrawApi.getAppState();
    const min = -50;
    const max = 50;
    const random = Math.random() * (max - min) + min;
    const element = createImageElement({
        height: image.height,
        width: image.width,
        fileId: image.id,
        x: (-state.scrollX + state.width / 2 - image.width / 2) + random,
        y: (-state.scrollY + state.height / 2 - image.height / 2) + random,
    });
    addElementsToExcalidraw(excalidrawApi, element);
    if (!image.alreadyExists) {
        conference.sendMessage({
            type: ENDPOINT_MESSAGE_RECEIVED_COLLAB_IMAGES_IMAGE_ID,
            payload: { id: image.id }
        });
    }
    dispatch({
        type: CollabImageActionTypes.SHARE_IMAGE_UPLOAD_SUCCESS,
        payload: { image }
    });
    callback?.(true);
};
/**
 * Signals a failure to upload.
 */
export const shareImageUploadFailure = (error) => ({
    type: CollabImageActionTypes.SHARE_IMAGE_UPLOAD_FAILURE,
    payload: { cause: error }
});
/**
 * Generic “share image” thunk factory. Validates state, prevents concurrent
 * uploads, then invokes shareImageUploadStart().
 *
 * @param uploadFn – given (service, roomId) → Promise<UploadedImageResponse>
 * @param excalidrawApi – Excalidraw API to render new element
 */
function shareImage(uploadFn, excalidrawApi, callback) {
    return (dispatch, getState) => {
        dispatch(shareImageIntent());
        const tegoServer = getState()['features/tego-server'];
        if (!tegoServer.isEnabled) {
            dispatch(shareImageBlocked("Caracteristica no habilitada."));
            callback?.(false);
            return;
        }
        const images = excalidrawApi.getSceneElements().filter(e => e.type === 'image');
        if (images.length >= 6) {
            dispatch(shareImageBlocked("6 de 6 imegenes, pruebe a borrar algunas"));
            callback?.(false);
            return;
        }
        const { conference, room } = getState()['features/base/conference'];
        if (!conference || !room) {
            dispatch(shareImageBlocked("Conferencia no habilitada."));
            callback?.(false);
            return;
        }
        if (getCollabImagesState(getState()).isUploading) {
            dispatch(shareImageBlocked('Aun se esta subiendo una imagen, espere un momento.'));
            callback?.(false);
            return;
        }
        dispatch(shareImageUploadStart(() => uploadFn(new CollabImagesServiceV2(tegoServer.urls.tego), room), conference, excalidrawApi, callback));
    };
}
/**
 * Share a Blob file.
 */
export const shareBlobImage = (blob, excalidrawApi, callback) => shareImage((svc, roomId) => svc.uploadImageFile(roomId, blob), excalidrawApi, callback);
/**
 * Share an external URL image.
 */
export const shareUrlImage = (url, excalidrawApi, callback) => shareImage((svc, roomId) => svc.uploadImageFromUrl(roomId, url), excalidrawApi, callback);
export function joinRoom(roomId) {
    return async (dispatch, getState) => {
        dispatch(joinRoomRequest(roomId));
        const tegoServer = getState()['features/tego-server'];
        if (!tegoServer.isEnabled) {
            dispatch(shareImageBlocked("Caracteristica no habilitada."));
            return;
        }
        const { room } = getState()['features/base/conference'];
        if (!room) {
            dispatch(shareImageBlocked("Conferencia no habilitada."));
            return;
        }
        try {
            const images = await new CollabImagesServiceV2(tegoServer.urls.tego).getGroupImages(roomId);
            startPing(tegoServer.urls.tego, roomId);
            dispatch(joinRoomSuccess(roomId, images));
        }
        catch (error) {
            console.log(error);
            dispatch(joinRoomFailure('Error al entrar a la sala'));
        }
    };
}
export function setExcalidrawApi(excalidrawApi) {
    return {
        type: CollabImageActionTypes.SET_EXCALIDRAW_API,
        payload: {
            excalidrawApi
        }
    };
}
export function removeImage(id, notifyServer = false) {
    return async (dispatch, getState) => {
        const { conference, room } = getState()['features/base/conference'];
        const { excalidrawApi } = getState()['features/collab-images'];
        const tegoServer = getState()['features/tego-server'];
        if (!conference || !room || !excalidrawApi || !tegoServer.isEnabled)
            return;
        if (notifyServer) {
            const service = new CollabImagesServiceV2(tegoServer.urls.tego);
            try {
                await service.removeImage(id);
                conference.sendMessage({
                    type: ENDPOINT_MESSAGE_REMOVE_IMAGE,
                    payload: { id }
                });
            }
            catch (error) {
                console.log("test", error);
                dispatch(showErrorNotification({
                    title: 'Error',
                    description: 'Error al eliminar la imagen',
                    hideErrorSupportLink: true
                }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
                return;
            }
        }
        excalidrawApi.addFiles([{ mimeType: 'image/jpeg', id: id, created: Date.now(), dataURL: null }]);
        excalidrawApi.updateScene({
            elements: excalidrawApi.getSceneElementsIncludingDeleted().filter(el => {
                if (el.type !== 'image')
                    return true;
                return el.fileId !== id;
            }),
            commitToHistory: false
        });
        dispatch({
            type: CollabImageActionTypes.REMOVE_IMAGE,
            payload: {
                id,
                notifyServer
            }
        });
    };
}
